import {
  LessonPlanProperties,
  MultigradeLessonPlanProperties,
} from 'apps/web/enums/pageKey';
import { getLocalStorageItem } from 'apps/web/utils/helper';

import { Language } from '@lessonPlanner/enums';

import FORM_KEYS from './formKeys';

const formDefaultValues = () => ({
  LocalLp: {
    [FORM_KEYS.gradeLevel]: getLocalStorageItem(
      LessonPlanProperties.gradeLevel,
    ),
    [FORM_KEYS.subject]: getLocalStorageItem(LessonPlanProperties.subject),
    [FORM_KEYS.language]: getLocalStorageItem(
      LessonPlanProperties.language,
      Language.ENGLISH,
    ),
    [FORM_KEYS.lessonFormat]: getLocalStorageItem(
      LessonPlanProperties.lessonFormat,
    ),
    [FORM_KEYS.objective]: getLocalStorageItem(LessonPlanProperties.objective),
    [FORM_KEYS.objective2]: getLocalStorageItem(
      LessonPlanProperties.objective2,
    ),
    [FORM_KEYS.objective3]: getLocalStorageItem(
      LessonPlanProperties.objective3,
    ),
    [FORM_KEYS.objective4]: getLocalStorageItem(
      LessonPlanProperties.objective4,
    ),
  },
  DefaultLP: {
    [FORM_KEYS.subject]: getLocalStorageItem(LessonPlanProperties.subject),
    [FORM_KEYS.gradeLevel]: getLocalStorageItem(
      LessonPlanProperties.gradeLevel,
    ),
    [FORM_KEYS.time]: getLocalStorageItem(LessonPlanProperties.time),
    [FORM_KEYS.modality]: getLocalStorageItem(LessonPlanProperties.modality),
    [FORM_KEYS.lessonFormat]: 'defaultLessonPlan',
    [FORM_KEYS.objective]: getLocalStorageItem(LessonPlanProperties.objective),
    [FORM_KEYS.objective2]: getLocalStorageItem(
      LessonPlanProperties.objective2,
    ),
    [FORM_KEYS.objective3]: getLocalStorageItem(
      LessonPlanProperties.objective3,
    ),
    [FORM_KEYS.language]: getLocalStorageItem(
      LessonPlanProperties.language,
      Language.ENGLISH,
    ),
  },

  MontessoriLP: {
    [FORM_KEYS.title]: getLocalStorageItem(LessonPlanProperties.title),
    [FORM_KEYS.classProgram]: getLocalStorageItem(
      LessonPlanProperties.classProgram,
    ),
    [FORM_KEYS.language]: getLocalStorageItem(
      LessonPlanProperties.language,
      Language.ENGLISH,
    ),
    [FORM_KEYS.lessonFormat]: 'montessoriLp',
    [FORM_KEYS.materials]: getLocalStorageItem(
      LessonPlanProperties.materials,
      'none',
    ),
    [FORM_KEYS.prerequisites]: getLocalStorageItem(
      LessonPlanProperties.prerequisites,
    ),
    [FORM_KEYS.keyArea]: getLocalStorageItem(LessonPlanProperties.keyArea),
    [FORM_KEYS.keyArea2]: getLocalStorageItem(LessonPlanProperties.keyArea2),
    [FORM_KEYS.keyArea3]: getLocalStorageItem(LessonPlanProperties.keyArea3),
    [FORM_KEYS.objective]: getLocalStorageItem(LessonPlanProperties.objective),
    [FORM_KEYS.objective2]: getLocalStorageItem(
      LessonPlanProperties.objective2,
    ),
    [FORM_KEYS.objective3]: getLocalStorageItem(
      LessonPlanProperties.objective3,
    ),
  },

  AmericanLP: {
    [FORM_KEYS.lessonFormat]: 'americanLp',
    [FORM_KEYS.language]: getLocalStorageItem(
      LessonPlanProperties.language,
      Language.ENGLISH,
    ),
    [FORM_KEYS.curriculumFramework]: getLocalStorageItem(
      LessonPlanProperties.curriculumFramework,
    ),
    [FORM_KEYS.gradeLevel]: getLocalStorageItem(
      LessonPlanProperties.gradeLevel,
    ),
    [FORM_KEYS.subject]: getLocalStorageItem(LessonPlanProperties.subject),
    [FORM_KEYS.specificStandards]: getLocalStorageItem(
      LessonPlanProperties.specificStandards,
    ),
    [FORM_KEYS.objective]: getLocalStorageItem(LessonPlanProperties.objective),
    [FORM_KEYS.objective2]: getLocalStorageItem(
      LessonPlanProperties.objective2,
    ),
    [FORM_KEYS.objective3]: getLocalStorageItem(
      LessonPlanProperties.objective3,
    ),
    [FORM_KEYS.strategies]: getLocalStorageItem(
      LessonPlanProperties.strategies,
    ),
    [FORM_KEYS.time]: getLocalStorageItem(LessonPlanProperties.time),
  },

  MultigradeLP: {
    [FORM_KEYS.gradeLevel]: getLocalStorageItem(
      MultigradeLessonPlanProperties.gradeLevel,
    ),
    [FORM_KEYS.subject]: getLocalStorageItem(
      MultigradeLessonPlanProperties.subject,
    ),
    [FORM_KEYS.language]: getLocalStorageItem(
      MultigradeLessonPlanProperties.language,
      Language.ENGLISH,
    ),
    [FORM_KEYS.lessonFormat]: getLocalStorageItem(
      MultigradeLessonPlanProperties.lessonFormat,
    ),
    [FORM_KEYS.objective]: getLocalStorageItem(
      MultigradeLessonPlanProperties.objective,
    ),
    [FORM_KEYS.objective2]: getLocalStorageItem(
      MultigradeLessonPlanProperties.objective2,
    ),
    [FORM_KEYS.objective3]: getLocalStorageItem(
      MultigradeLessonPlanProperties.objective3,
    ),
  },
});

export default formDefaultValues;
